import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { List } from '../../shared/list';

import { PortAggregate } from '../../_models/port-aggregate';
import { PortAggregateFilter } from '../../_models/port-aggregate';
import { PortAggregateService } from '../../_services/port-aggregate.service';
import { DebarkationImportedService } from '../../_services/debarkation-imported.service';
import { Profile } from '../../_models/profile';

@Component({
  selector: 'app-port-list',
  templateUrl: './port-list.component.html',
  styleUrls: ['./port-list.component.css'],
})
export class PortListComponent extends List implements OnInit {
  errorMessage: string;
  filter: PortAggregateFilter = new PortAggregateFilter();
  public profile: Profile;

  constructor(
    private portAggregateService: PortAggregateService,
    private debarkationImportedService: DebarkationImportedService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(portAggregateService, new PortAggregate(), router, route);
  }

  ngOnInit() {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.initList('ports', this.filter).then((result) => {});
  }
  listCallback() {
    if (this.profile.haveAccess('import')) {
      const params = this.filter.serializeQueryParams(this.params);
      this.getImportedDebarkations(this.collection, params);
    }
  }
  getImportedDebarkations(collection, params) {
    this.debarkationImportedService.list(1, 10000, params, '').subscribe(
      (response) => {
        for (const importedDebarkation of response.results) {
          let findedPort = false;
          for (const port of collection) {
            if (importedDebarkation.port_name === port.port_name) {
              // let imported_and_dea_debarkations = Object.assign(port, importedDebarkation)
              findedPort = true;
              for (const importedStock of importedDebarkation.data) {
                let findedStock = false;
                for (let stock of port.data) {
                  if (importedStock.specie_fao_code === stock.specie_fao_code) {
                    findedStock = true;
                    stock = Object.assign(stock, importedStock);
                  }
                }
                if (!findedStock) {
                  port.data.push(importedStock);
                } else {
                }
              }
            }
          }
          if (!findedPort) {
            collection.push(importedDebarkation);
          }
        }
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/ports/port-list/port-list.component.ts